import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import VendorAddressForm from './VendorAddressForm';
import {
  getVendorAddressFields,
  getGeoCitiesByState,
  getGeoPincodesByCity,
  getVendorOnboardingList,
} from 'services/redux/sales/vendorPortal/action';

const mapStateToProps = (state) => ({
  vendorOnboardedList: state.vendorPortalReducer.vendorOnboardedList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getVendorAddressFields,
      getGeoCitiesByState,
      getGeoPincodesByCity,
      getVendorOnboardingList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(VendorAddressForm);
